import { MouseEvent, useCallback, useMemo } from 'react';
import { localPoint } from '@visx/event';

import {
  LineChartData,
  LineChartSeries,
} from '@components/patterns/LineChart/types';
import { UseScalesResult } from '@components/patterns/LineChart/use-scales';

export function useInteractions<Data extends LineChartData>(
  series: LineChartSeries<Data, any>[],
  scales: UseScalesResult,
  callbacks: {
    onClick?: (data: Data[], index: number) => void;
  }
) {
  const handleClick = useCallback(
    (event: MouseEvent<SVGRectElement>) => {
      const point = localPoint(event) || { x: 0, y: 0 };
      const index = Math.floor(scales.index.invert(point.x));
      const domain = scales.index.domain();
      if (index < domain[0] || index > domain[1]) return;

      const dataPts = series.flatMap((s) => s.data.at(index) ?? []);
      if (dataPts.length !== series.length) return;
      if (dataPts.every(({ y }) => y === 0)) return;
      callbacks.onClick?.(dataPts, index);
    },
    [callbacks.onClick, scales, series]
  );

  return useMemo(() => ({ onClick: handleClick }), [handleClick]);
}
